import { render, staticRenderFns } from "./quick_task_filters.vue?vue&type=template&id=56759740"
import script from "./quick_task_filters.vue?vue&type=script&lang=js"
export * from "./quick_task_filters.vue?vue&type=script&lang=js"
import style0 from "./quick_task_filters.vue?vue&type=style&index=0&id=56759740&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports